import React from 'react';
import SectionTitle from '../common/SectionTitle';

const QmsContentThree = () => {
  return (
    <>
      <section className='why-choose-us pt-60 pb-120'>
        <div className='container'>
          <div className='row justify-content-lg-between justify-content-center align-items-center'>
            <div className='col-lg-5 col-md-7 order-1 order-lg-0'>
              <div className='why-choose-img position-relative'>
                <img
                  src='assets/img/feature-hero-img-2.svg'
                  className='img-fluid'
                  alt='duel-phone'
                />
              </div>
            </div>
            <div className='col-lg-6 col-md-12 order-0 order-lg-1'>
              <div className='why-choose-content'>
                <div className='mb-32'>
                  <SectionTitle
                    title='Empower Your Quality Journey with Integrated Solutions!

                    '                   
                    leftAlign
                  />
                </div>
                <p>Introducing our comprehensive Quality Management Software feature, seamlessly integrating Change Control, Deviation, Risk Management, and CAPA processes. Effortlessly manage document preparation, review cycles, comment resolution, and electronic signatures within a unified platform. Maintain impeccable version control, ensuring accuracy and compliance throughout. Streamline your quality processes and elevate operational excellence with this all-encompassing software solution.</p>
                
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default QmsContentThree;
